<template>
    <header>
        <div class="container-fluid">
            <div class="header-logo">
                <a href="/">
                    <img src="/img/animate_logo.gif" alt="Store Glide" class="logo">
                    <img src="/img/logo_strgld_white.gif" alt="Store Glide" class="mobile-logo"/>
                </a>
            </div>
            <div class="wrapper-controls">
                <base-drop-down-menu label="Products">
                    <base-drop-down-item link="/live" label="Live view"></base-drop-down-item>
                    <base-drop-down-item link="/top" label="Top charts"></base-drop-down-item>
                    <base-drop-down-item link="/collections" label="Collections"></base-drop-down-item>
                </base-drop-down-menu>
                <div class="user-panel" v-if="authUser">
                    <img :src="avatar" class="avatar">
                    <a class="btn" href="/auth/logout">Log out</a>
                </div>
                <form v-else>
                    <button type="button" data-toggle="modal" data-target="#loginModal" class="btn login-btn">Log in</button>
                </form>
            </div>
            <div class="mobile-control">
                <button class="menu-btn" @click="openMobileMenu"><img src="/img/header_burger.svg"></button>
            </div>
        </div>
    </header>
</template>

<script>
import BaseDropDownMenu from '../ui/BaseDropDownMenu';
import BaseDropDownItem from '../ui/parts/BaseDropDownItem';
import { mapMutations } from 'vuex';

export default {
    inheritAttrs: false,
    name: 'main-header',
    components: {
        BaseDropDownMenu,
        BaseDropDownItem
    },
    methods: {
        ...mapMutations(['setMobileMenuActive']),
        openMobileMenu() {
            document.documentElement.classList.add('blocked')
            document.body.classList.add('blocked')
            this.setMobileMenuActive();
        }
    },
    data() {
        return {
            authUser: window.authUser,
            avatar: window.avatar
        };
    },
};
</script>

<style scoped lang="scss">
    header {
        padding: 30px 40px;

        .wrapper-controls {
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        .user-panel {
            margin-left: 10px;
        }
    }
    @media only screen and (max-width: 991px) {
        header {
            .wrapper-controls {
                display: none;
            }
            .header-logo {
                .logo {
                    display: none;
                }
            }
        }

    }
    @media only screen and (max-width: 485px) {
        .main-page header {
            padding: 20px 10px;
        }
    }
</style>

